const ID = 'search';

export default ID;
